import axios from 'axios';

const axiosLib = axios.create();

export { axiosLib };
